import {cookie} from '../modules/cookie';

/*
* Используется в составе голосовалки
* Это подсказка о том, что при голосовании "Пойду" попап автоматом добавляется в избранное
*
* */
var comeToFavPopup = function(){
    var template = document.getElementById('comeToFavTemplate').innerHTML,
        popupEl = undefined,
        closeBtn = undefined,
        remember = function(){
            var options = {};

            options.expires = 60*60*24*365*10;
            options.path = '/';
            options.domain = '.v4.kinoafisha';

            cookie.setCookie('ka_come_to_fav_popup', '1', options);
        },
        remove = function(){
            closeBtn.removeEventListener('click', hidePopup);
            document.body.removeChild(popupEl);
            popupEl = undefined;
            closeBtn = undefined;
        },
        hidePopup = function(){
            remember();
            remove();
        },
        createPopup = function(data){
            var div = document.createElement('DIV');
            div.innerHTML = APP.helpers.templateEngine(template, data);
            popupEl = div.firstElementChild;
            closeBtn =  popupEl.querySelector('[data-comeToFavPopup-close]');
            closeBtn.addEventListener('click', hidePopup);
        },
        show = function(box, data){
            /*
            * Показываем попап
            * Мы не вызыаем эту функцию, если при ответе на голосовалку нет hint:true
            * Поэтому здесь кука проверяется на всякий пожарный
            *
            * Аналогично, шаблон попапа вставляется в разметку только когда нужно
            * Проверяем его наличие на всякий пожарный
            *
            * Если пользователь закрывает попап - ставим бессрочную куку, которая отслеживается на стороне сервера
            * */

            //if(cookie.getCookie('ka_come_to_fav_popup')) return;
            if(!template) return;

            var rect = box.getBoundingClientRect(),
                left = rect.left + window.pageXOffset,
                bottom = rect.bottom + window.pageYOffset;

            if(popupEl) remove();
            createPopup(data);
             
            popupEl.style.cssText = 'left:' + left + 'px; top:' + bottom + 'px';
            document.body.appendChild(popupEl);
            requestAnimationFrame(function(){
                requestAnimationFrame(function(){
                    popupEl.classList.add('js-active');
                })
            });
        },
        returnObj = {
            show:show
        };

    //
    return returnObj;
}

export {comeToFavPopup};


